<mat-form-field class="full-width" appearance="outline">
  <mat-label>{{ formLabel ?? "Address" | translate }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    placeholder="{{ placeholder ?? 'Address' | translate }}"
    [required]="required"
    [formControl]="getFormControl()"

  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSuggestedAutocompleteOptionSelected($event)">
    <mat-option *ngFor="let option of suggestedStreetAddressOptions" [id]="option.placeId">
      {{ option.text.text }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>